import { render } from "./DotsHorizontal.vue?vue&type=template&id=a8ba8946"
import script from "./DotsHorizontal.vue?vue&type=script&lang=js"
export * from "./DotsHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__